import React, { useState, useEffect } from 'react';
import { 
    ArrowRight, Clock, User, Grid, MapPin, X 
} from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { base_api_url } from '../../../environment.jsx';
import { all_routes } from '../../../Router/all_routes.jsx';
import './AccueilNew.css';
import '../commandes/CommandsNew.css'; // Pour réutiliser les styles de la modal

const AccueilNew = () => {
    const [prenom, setPrenom] = useState("Admin");
    const [devise, setDevise] = useState("€");
    const [DashboardData, setDashboardData] = useState(null);
    const [latestCommands, setLatestCommands] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTemps, setSelectedTemps] = useState(1);
    const [selectedCommand, setSelectedCommand] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Modal liste des commandes (card Commandes)
    const [ordersListModal, setOrdersListModal] = useState(false);
    const [ordersListData, setOrdersListData] = useState([]);
    const [ordersListLoading, setOrdersListLoading] = useState(false);
    const [ordersListTitle, setOrdersListTitle] = useState("");

    const MySwal = withReactContent(Swal);

    // Fonction globale de rafraîchissement
    const refreshAll = () => {
        fetchdata();
        fetchLatestCommands();
    };

    // Initialisation user et devise (comme Accueil.jsx)
    useEffect(() => {
        const restaurantData = JSON.parse(localStorage.getItem("restaurant"));
        if (restaurantData?.restaurant?.devise) {
            setDevise(restaurantData.restaurant.devise);
        }
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const userData = JSON.parse(storedUser);
                if (userData.prenom) setPrenom(userData.prenom);
                else if (userData.nom) setPrenom(userData.nom);
            } catch (err) {
                console.error("Erreur lecture user:", err);
            }
        }
    }, []);

    // Fetch API exactement comme Accueil.jsx
    const fetchdata = async () => {
        setLoading(true);

        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;

        if (!token || !ideresto) {
            setLoading(false);
            return;
        }

        try {
            const response = await axios.get(
                `${base_api_url}api/commandes/dashboard`,
                {
                    params: { restoId: ideresto, temps: selectedTemps },
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            console.log("Performance API (New):", response.data);

            if (!response.data || !response.data.statistiques_globales) {
                MySwal.fire({
                    icon: "info",
                    text: "Aucune donnée trouvée pour cette période.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                });
                setDashboardData(null);
                return;
            }

            setDashboardData(response.data);

        } catch (error) {
            console.error("Erreur chargement des donneés:", error);
            MySwal.fire({
                icon: "error",
                text: "Erreur lors du chargement des données.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchLatestCommands = async () => {
        const userStr = localStorage.getItem("user");
        if (!userStr) return;

        const user = JSON.parse(userStr);
        const { access_token, restoId } = user;

        if (!access_token || !restoId) return;

        try {
            const url = `${base_api_url}api/commande/restaurant/${restoId}/dernieres-24h`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${access_token}` },
            });

            if (response.data && response.data.commandes) {
                // Trier par date décroissante et prendre les 5 dernières
                const sorted = [...response.data.commandes]
                    .sort((a, b) => new Date(b.date_commande) - new Date(a.date_commande))
                    .slice(0, 5);
                setLatestCommands(sorted);
            }
        } catch (error) {
            console.error("Erreur chargement dernières commandes:", error);
        }
    };

    useEffect(() => {
        refreshAll();

        // Rafraîchissement automatique toutes les 2 minutes (120000 ms)
        const interval = setInterval(() => {
            console.log("Rafraîchissement automatique du dashboard...");
            refreshAll();
        }, 120000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTemps]);

    const handleTempsChange = (e) => {
        setSelectedTemps(parseInt(e.target.value));
    };

    const getPeriodText = () => {
        if (selectedTemps === 1) return "Aujourd'hui";
        if (selectedTemps === 2) return "Cette semaine";
        if (selectedTemps === 3) return "Ce mois";
        return "Cette semaine";
    };


    const getCanalLabel = (typeTable) => {
        if (typeTable === null || typeTable === 1) return "Classique";
        if (typeTable === 2) return "Livraison";
        if (typeTable === 3) return "QR Code Client";
        return "Autre";
    };

    const getStatusLabel = (statut, statutPaiement) => {
        if (statut === 10) return "À valider";
        if (statut === 2 || statut === 3) return "En préparation";
        if (statut === 4) return "À servir";
        if (statut === 5 && statutPaiement === 1) return "Livré";
        if (statut === 5 && statutPaiement === 2) return "Terminée";
        if (statut === 0) return "Annulée";
        return "Inconnu";
    };

    const statusColors = {
        "À valider": { bg: "#FEE2E2", text: "#991B1B", border: "#EF4444" },
        "En préparation": { bg: "#FFEDD5", text: "#9A3412", border: "#F97316" },
        "À servir": { bg: "#DCFCE7", text: "#166534", border: "#22C55E" },
        "Livré": { bg: "#DBEAFE", text: "#1E40AF", border: "#3B82F6" },
        "Terminée": { bg: "#F3F4F6", text: "#374151", border: "#9CA3AF" },
        "Annulée": { bg: "#F3F4F6", text: "#6B7280", border: "#374151" },
        "Inconnu": { bg: "#F3F4F6", text: "#6B7280", border: "#374151" },
    };

    const handleOpenModal = (cmd) => {
        setSelectedCommand(cmd);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        // setSelectedCommand(null); // Optionnel, on peut garder pour l'animation
    };

    // Ouvre le modal liste des commandes pour la card Commandes
    const handleOpenOrdersList = async () => {
        setOrdersListModal(true);
        setOrdersListLoading(true);
        setOrdersListData([]);
        setOrdersListTitle(`Commandes — ${getPeriodText()}`);
        try {
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
            if (!token || !ideresto) return;
            const response = await axios.get(
                `${base_api_url}api/commandes/dashboard`,
                {
                    params: { restoId: ideresto, temps: selectedTemps },
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const list = (response.data?.tendances?.liste_commande_filtre ?? [])
                .filter(cmd => cmd.statut !== 10) // exclure "À valider"
                .map(cmd => ({
                ...cmd,
                _canalStr: cmd.canal ?? null,
                statut_paiement: cmd.statut_paiement ?? null,
            }));
            setOrdersListData(list);
        } catch (err) {
            console.error("Erreur chargement liste commandes:", err);
        } finally {
            setOrdersListLoading(false);
        }
    };

    // ---- Export CSV ----
    const exportCSV = () => {
        if (!ordersListData.length) return;
        const headers = ['Référence', 'Date & heure', 'Canal', 'Statut', 'Montant'];
        const rows = ordersListData.map(cmd => {
            const statusLabel = getStatusLabel(cmd.statut, cmd.statut_paiement);
            const canal = cmd._canalStr || cmd.canal || getCanalLabel(cmd.table_restaurant?.type_table ?? cmd.type_table);
            const montant = cmd.prix_commande ?? cmd.prix ?? (cmd.details?.reduce((s, d) => s + (d.prix_total || 0), 0) ?? 0);
            const ref = cmd.reference ? cmd.reference.toString().replace(/#/g,'').split('-').pop() : (cmd.id_commande ?? '');
            return [`#${ref}`, formatDate(cmd.date_commande), canal, statusLabel, `${montant} ${devise}`]
                .map(v => `"${String(v).replace(/"/g, '""')}"`).join(';');
        });
        const bom = '\uFEFF';
        const csv = bom + [headers.join(';'), ...rows].join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `commandes_${getPeriodText().replace(/\s+/g,'_').toLowerCase()}_${new Date().toISOString().slice(0,10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    // ---- Export PDF via iframe print ----
    const exportPDF = () => {
        if (!ordersListData.length) return;
        const sc2 = { 'À valider':{bg:'#FEE2E2',text:'#DC2626'}, 'En préparation':{bg:'#FED7AA',text:'#EA580C'}, 'À servir':{bg:'#D1FAE5',text:'#059669'}, 'Livré':{bg:'#DBEAFE',text:'#2563EB'}, 'Terminée':{bg:'#E5E7EB',text:'#374151'}, 'Annulée':{bg:'#E5E7EB',text:'#6B7280'} };
        const totalPeriode = ordersListData.reduce((s,c) => s+(c.prix_commande??c.prix??(c.details?.reduce((a,d)=>a+(d.prix_total||0),0)??0)), 0);
        const totalEncaisse = ordersListData.filter(c=>c.statut_paiement===2).reduce((s,c)=>s+(c.prix_commande??c.prix??0),0);
        const rows = ordersListData.map(cmd => {
            const sl = getStatusLabel(cmd.statut, cmd.statut_paiement);
            const c = sc2[sl]||{bg:'#f1f5f9',text:'#64748b'};
            const canal = cmd._canalStr||cmd.canal||getCanalLabel(cmd.table_restaurant?.type_table??cmd.type_table);
            const m = cmd.prix_commande??cmd.prix??(cmd.details?.reduce((s,d)=>s+(d.prix_total||0),0)??0);
            const ref = cmd.reference?cmd.reference.toString().replace(/#/g,'').split('-').pop():(cmd.id_commande??'');
            return `<tr><td><span style="background:#f1f5f9;padding:2px 6px;border-radius:4px;font-family:monospace">#${ref}</span></td><td>${formatDate(cmd.date_commande)}</td><td>${canal}</td><td><span style="background:${c.bg};color:${c.text};padding:2px 8px;border-radius:10px;font-weight:600">${sl}</span></td><td style="text-align:right;font-weight:700">${m.toLocaleString('fr-FR')} ${devise}</td></tr>`;
        }).join('');
        const html = `<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Commandes</title><style>body{font-family:Arial,sans-serif;font-size:12px;color:#1e293b;padding:20px}h2{font-size:16px;margin-bottom:4px}p.meta{font-size:11px;color:#64748b;margin-bottom:16px}table{width:100%;border-collapse:collapse}thead tr{background:#f8fafc}th{padding:8px 10px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#64748b;border-bottom:2px solid #e2e8f0}td{padding:8px 10px;border-bottom:1px solid #f1f5f9;vertical-align:middle}.foot{margin-top:16px;display:flex;justify-content:space-between;font-size:11px;color:#475569;border-top:2px solid #e2e8f0;padding-top:10px}strong{color:#0f172a}</style></head><body><h2>QRNYAMA – ${ordersListTitle}</h2><p class="meta">Généré le ${new Date().toLocaleString('fr-FR')} • ${ordersListData.length} commande(s)</p><table><thead><tr><th>Référence</th><th>Date &amp; heure</th><th>Canal</th><th>Statut</th><th style="text-align:right">Montant</th></tr></thead><tbody>${rows}</tbody></table><div class="foot"><span>Total encaissé : <strong>${totalEncaisse.toLocaleString('fr-FR')} ${devise}</strong></span><span>Total période : <strong>${totalPeriode.toLocaleString('fr-FR')} ${devise}</strong></span></div><script>window.onload=()=>{window.print();setTimeout(()=>window.close(),500)}${'</script>'}</body></html>`;
        const iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;';
        document.body.appendChild(iframe);
        iframe.contentDocument.write(html);
        iframe.contentDocument.close();
        setTimeout(() => document.body.removeChild(iframe), 3000);
    };

    const formatDate = (dateString) => {
        try {
            if (!dateString) return "--";
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return "--";

            return date.toLocaleString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        } catch (error) {
            return "--";
        }
    };

    const formatMontant = (m) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(m) + ` ${devise}`;

    // Valeurs calculées dynamiquement
    const ventesTotales = DashboardData?.statistiques_globales?.chiffre_affaires ?? 0;
    const taux_evolution_ca = DashboardData?.statistiques_globales?.taux_evolution_ca ?? 0.0;
    const commandesCount = DashboardData?.statistiques_globales?.commande_active ?? 0;
    const taux_evolution_cmd = DashboardData?.statistiques_globales?.taux_evolution_cmd ?? 0.0;
    const taux_evolution_ticket = DashboardData?.statistiques_globales?.taux_evolution_ticket ?? 0.0;
    const ticketMoyen = commandesCount > 0 ? (ventesTotales / commandesCount) : 0;


    // Alertes stock
    const alertes = DashboardData?.tendances?.alerte ?? [];

    // Tableaux de data dynamiques (à ajuster selon la structure réelle du JSON si différente)
    const dataCanal = DashboardData?.tendances?.ventes_par_canal ?? [];

    // Pour mapper des couleurs par défaut si elles ne sont pas fournies par l'API
    const defaultColors = ['#f97316', '#38bdf8', '#a855f7', '#10b981', '#ef4444'];

    const meilleursPlats = DashboardData?.tendances?.meilleurs_plats ?? [];

    const meilleursServeurs = DashboardData?.tendances?.meilleurs_serveurs ?? [];

    // Calcul dynamique du graphique Donut Ventes par canal
    const totalAmount = dataCanal.reduce((sum, item) => sum + (item.amount || item.montant || item.total || 0), 0);
    let currentPercent = 0;
    const gradientString = dataCanal.map((item, index) => {
        const amount = item.amount || item.montant || item.total || 0;
        const percent = totalAmount > 0 ? (amount / totalAmount) * 100 : 0;
        const color = item.color || defaultColors[index % defaultColors.length];
        const start = currentPercent;
        currentPercent += percent;
        return `${color} ${start}% ${currentPercent}%`;
    }).join(', ');

    return (
        <div className="page-wrapper dashboard-page">
            <div className="dashboard-container">

                {/* Header */}
                <div className="dashboard-header">
                    <h2>Bienvenue, {prenom} !</h2>
                    <p>
                        Vue d&apos;ensemble de votre activité
                        {loading && <span className="spinner-border spinner-border-sm text-primary ms-2" role="status" aria-hidden="true"></span>}
                    </p>
                </div>
                <div className="dashboard-separator"></div>

                <div className="dashboard-grid">
                    {/* Left Column */}
                    <div className="dashboard-left">
                        {/* 3 Stats Cards */}
                        <div className="stats-row">
                            <div className="stat-card stat-orange" onClick={handleOpenOrdersList} style={{ cursor: 'pointer' }}>
                                <div className="stat-value">{formatMontant(ventesTotales)}</div>
                                <div className="stat-info line-clamp-1">
                                    <div className="stat-title">Ventes totales</div>
                                    <div className="stat-period"><span className="trend-up">{taux_evolution_ca}%</span> {getPeriodText()}</div>
                                </div>
                            </div>
                            <div className="stat-card stat-blue" onClick={handleOpenOrdersList} style={{ cursor: 'pointer' }}>
                                <div className="stat-value">{commandesCount}</div>
                                <div className="stat-info line-clamp-1">
                                    <div className="stat-title">Commandes</div>
                                    <div className="stat-period"><span className="trend-up">{taux_evolution_cmd}%</span> {getPeriodText()}</div>
                                </div>
                            </div>
                            <div className="stat-card stat-green">
                                <div className="stat-value">{formatMontant(ticketMoyen)}</div>
                                <div className="stat-info line-clamp-1">
                                    <div className="stat-title">Ticket moyen</div>
                                    <div className="stat-period"><span className="trend-down">{taux_evolution_ticket}%</span> {getPeriodText()}</div>
                                </div>
                            </div>
                        </div>

                        {/* Charts Area */}
                        <div className="">
                            <div className="chart-card channel-card mb-3">
                                <div className="card-header">
                                    <h5>Ventes par canal</h5>
                                    <div className="card-filter dashboard-select-filter">
                                        <select value={selectedTemps} onChange={handleTempsChange} className="dashboard-select">
                                            <option value={1}>Aujourd&apos;hui</option>
                                            <option value={2}>Cette semaine</option>
                                            <option value={3}>Ce mois</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="canal-chart-wrapper">
                                    <div className="donut-chart" style={{ background: totalAmount > 0 ? `conic-gradient(${gradientString})` : '#f1f5f9' }}>
                                        <div className="donut-inner"></div>
                                    </div>
                                    <div className="canal-legend">
                                        {dataCanal.map((item, index) => (
                                            <div className="legend-item" key={index}>
                                                <div className="legend-label">
                                                    <span className="dot" style={{ backgroundColor: item.color || defaultColors[index % defaultColors.length] }}></span>
                                                    {item.label || item.canal || item.nom}
                                                </div>
                                                <div className="legend-value">{item.amount || item.montant || item.total || 0} {devise}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* <div className="chart-card compare-card">
                                <div className="empty-state-centered">
                                    <h5>Comparaison multi-restaurants</h5>
                                    <p>Disponible avec plusieurs restaurants</p>
                                </div>
                            </div> */}
                        </div>

                        {/* Recent Orders Section */}
                        <div className="section-block">
                            <div className="section-header">
                                <h5>Dernières commandes</h5>
                                <Link to={all_routes.commandsNew} className="link-action">Tout voir <ArrowRight size={14} /></Link>
                            </div>
                            <div className="table-wrapper">
                                <table className="orders-table">
                                    <thead>
                                        <tr>
                                            <th>Référence</th>
                                            <th>Date & heure</th>
                                            <th>Canal</th>
                                            <th>Statut</th>
                                            <th className="text-right">Montant</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {latestCommands.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="text-center py-4">Aucune commande récente</td>
                                            </tr>
                                        ) : (
                                            latestCommands.map((cmd, index) => {
                                                const statusLabel = getStatusLabel(cmd.statut, cmd.statut_paiement);
                                                const colorObj = statusColors[statusLabel] || statusColors["Inconnu"];
                                                return (
                                                    <tr key={index} onClick={() => handleOpenModal(cmd)} style={{ cursor: 'pointer' }}>
                                                        <td className="cmd-ref">{cmd.reference}</td>
                                                        <td className="cmd-date">{formatDate(cmd.date_commande)}</td>
                                                        <td className="cmd-canal">{getCanalLabel(cmd.table_restaurant?.type_table ?? cmd.type_table)}</td>
                                                        <td>
                                                            <span className="pill-status" style={{ backgroundColor: colorObj.bg, color: colorObj.text, padding: '4px 12px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                                                                {statusLabel}
                                                            </span>
                                                        </td>
                                                        <td className="text-right font-medium">
                                                            {formatMontant(
                                                                (cmd.details?.reduce((total, item) => total + (item.prix_total || item.prix || 0), 0)) || 
                                                                cmd.prix || 
                                                                cmd.prix_commande || 
                                                                0
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="dashboard-right">
                        {/* Top Dishes */}
                        <div className="section-block">
                            <div className="section-header">
                                <h5>Meilleurs plats</h5>
                                <Link to={all_routes.articlesNew} className="link-action">Voir plus <ArrowRight size={14} /></Link>
                            </div>
                            <div className="ranking-list">
                                {meilleursPlats.map((plat, index) => (
                                    <div className="ranking-item" key={index}>
                                        <div className="ranking-left">
                                            <div className="rank-badge">{index + 1}</div>
                                            <span className="rank-name">{plat.name || plat.nom_article || plat.nom}</span>
                                        </div>
                                        <div className="rank-value">{plat.price || plat.total || plat.montant || 0} {devise}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Top Waiters */}
                        <div className="section-block mt-s">
                            <div className="section-header">
                                <h5>Meilleurs serveurs</h5>
                                <Link to={all_routes.restoUsers} className="link-action">Voir plus <ArrowRight size={14} /></Link>
                            </div>
                            <div className="ranking-list">
                                {meilleursServeurs.map((serv, index) => (
                                    <div className="ranking-item" key={index}>
                                        <div className="ranking-left">
                                            <div className="rank-badge">{index + 1}</div>
                                            <span className="rank-name">{serv.name || serv.prenom || serv.nom}</span>
                                        </div>
                                        <div className="rank-value">{serv.val || serv.total || serv.commandes || 0}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Alerts Stock */}
                        <div className="section-block mt-s">
                            <div className="section-header">
                                <h5>Alertes stock</h5>
                                <Link to={all_routes.rawMaterials} className="link-action">Voir plus <ArrowRight size={14} /></Link>
                            </div>
                            <div className="stock-list">
                                {alertes.map((alerte, index) => {
                                    const uniteStr = alerte.unite ? String(alerte.unite) : "";
                                    const isZero = uniteStr.includes("0") || alerte.quantite <= 0;
                                    const level = alerte.level || (isZero ? "Rupture" : "Alerte");
                                    return (
                                        <div className="stock-item" key={index}>
                                            <span className="stock-name">{alerte.nom_ingredient || alerte.nom}</span>
                                            <div className="stock-right">
                                                <span className="stock-qty">{alerte.unite || alerte.quantite}</span>
                                                <span className={`stock-badge ${level === 'Rupture' ? 'badge-rupture' : 'badge-alerte'}`}>{level}</span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* COMMAND DETAILS MODAL (Pixel Perfect with CommandsNew.jsx) */}
            {isModalOpen && selectedCommand && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
                        {/* Modal Header */}
                        <div className="modal-header">
                            <h2 className="modal-title">
                                {(() => {
                                    const ref = selectedCommand.reference || selectedCommand.id_commande?.toString() || "";
                                    return ref.includes("-") ? ref.split("-").pop() : ref.replace("#", "");
                                })()}
                            </h2>
                            <button
                                className="modal-close-btn"
                                onClick={handleCloseModal}
                                aria-label="Fermer"
                            >
                                <X size={24} />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="modal-content">
                            <>
                                {/* Status Badges */}
                                <div className="modal-badges">
                                    <span
                                        className="modal-status-badge"
                                        style={{
                                            backgroundColor: statusColors[getStatusLabel(selectedCommand.statut, selectedCommand.statut_paiement)]?.bg,
                                            color: statusColors[getStatusLabel(selectedCommand.statut, selectedCommand.statut_paiement)]?.text,
                                        }}
                                    >
                                        {getStatusLabel(selectedCommand.statut, selectedCommand.statut_paiement)}
                                    </span>
                                    <span className="modal-type-badge">
                                        {getCanalLabel(selectedCommand.table_restaurant?.type_table) || "Client"}
                                    </span>
                                </div>

                                {/* Date and Server Info */}
                                <div className="modal-info-row">
                                    <div className="modal-info-item">
                                        <Clock size={16} />
                                        <span>{formatDate(selectedCommand.date_commande)}</span>
                                    </div>
                                    <div className="modal-info-item">
                                        <User size={16} />
                                        <span>
                                            {getCanalLabel(selectedCommand.table_restaurant?.type_table) === "Livraison"
                                                ? "Livraison"
                                                : getCanalLabel(selectedCommand.table_restaurant?.type_table) === "Classique"
                                                    ? selectedCommand.table_restaurant?.numero_table || selectedCommand.numtable || "--"
                                                    : selectedCommand.nom || "Client"}
                                        </span>
                                    </div>
                                </div>

                                {/* Articles Section */}
                                <div className="modal-section">
                                    <h3 className="modal-section-title">
                                        <Grid size={16} />
                                        Articles ({selectedCommand.details?.length || 0})
                                    </h3>
                                    <div className="modal-articles-list">
                                        {selectedCommand.details?.map((art, idx) => (
                                            <div key={idx} className="modal-article-item">
                                                <div className="modal-article-info">
                                                    <span className="modal-article-qty">
                                                        {art.quantite || 1} ×
                                                    </span>
                                                    <div className="modal-article-details">
                                                        <span className="modal-article-name">{art.article?.nom || "Article"}</span>
                                                        {art.article?.etiquette && (
                                                            <span className="modal-article-tag">{art.article.etiquette}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <span className="modal-article-price">{formatMontant(art.prix_total || art.prix_unitaire)}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Summary Section */}
                                <div className="modal-section">
                                    <h3 className="modal-section-title">Récapitulatif</h3>
                                    <div className="modal-summary">
                                        <div className="modal-summary-row">
                                            <span>Sous-total</span>
                                            <span>{formatMontant(selectedCommand.prix || 0)}</span>
                                        </div>
                                        <div className="modal-summary-row modal-summary-total">
                                            <span>Total</span>
                                            <span className="modal-total-price">
                                                {formatMontant(selectedCommand.details?.reduce((total, item) => total + (item.prix_total || item.prix || 0), 0) || selectedCommand.prix_commande || selectedCommand.prix)}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Delivery Address Section - Only show if exists */}
                                {selectedCommand.adresse_livraison && Object.keys(selectedCommand.adresse_livraison).length > 0 && (
                                    <div className="modal-section">
                                        <h3 className="modal-section-title">
                                            <MapPin size={16} />
                                            Adresse de livraison
                                        </h3>
                                        <div className="delivery-address-content" style={{ backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                                            {selectedCommand.adresse_livraison.nom && (
                                                <div style={{ marginBottom: '8px' }}>
                                                    <strong style={{ color: '#495057', fontSize: '14px' }}>
                                                        <User size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                                        {selectedCommand.adresse_livraison.nom}
                                                    </strong>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* History Section */}
                                <div className="modal-section">
                                    <h3 className="modal-section-title">Historique</h3>
                                    <div className="modal-history">
                                        {selectedCommand.date_commande && (
                                            <div className="modal-history-item">
                                                <span className="modal-history-dot"></span>
                                                <div className="modal-history-content">
                                                    <span className="modal-history-label">Commande créée</span>
                                                    <span className="modal-history-time">{formatDate(selectedCommand.date_commande)}</span>
                                                </div>
                                            </div>
                                        )}
                                        {selectedCommand.date_validation_serveuse && (
                                            <div className="modal-history-item">
                                                <span className="modal-history-dot"></span>
                                                <div className="modal-history-content">
                                                    <span className="modal-history-label">Envoyée en cuisine</span>
                                                    <span className="modal-history-time">{formatDate(selectedCommand.date_validation_serveuse)}</span>
                                                </div>
                                            </div>
                                        )}
                                        {selectedCommand.statut === 5 && (
                                            <div className="modal-history-item">
                                                <span className="modal-history-dot"></span>
                                                <div className="modal-history-content">
                                                    <span className="modal-history-label">Livrée</span>
                                                    <span className="modal-history-time">{formatDate(selectedCommand.date_validation_client || selectedCommand.date_commande)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        </div>

                        {/* Modal Footer Actions */}
                        <div className="modal-actions-footer">
                            <button className="modal-action-btn btn-close" onClick={handleCloseModal}>
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ===== MODAL LISTE DES COMMANDES ===== */}
            {ordersListModal && (
                <div
                    className="orders-list-overlay"
                    onClick={() => setOrdersListModal(false)}
                    style={{
                        position: 'fixed', inset: 0, zIndex: 9000,
                        background: 'rgba(15,23,42,0.55)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        padding: '1rem',
                        animation: 'olFadeIn 0.2s ease-out'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: '#fff',
                            borderRadius: '1.25rem',
                            width: '100%',
                            maxWidth: '860px',
                            maxHeight: '85vh',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 25px 60px -12px rgba(0,0,0,0.35)',
                            overflow: 'hidden',
                            animation: 'olSlideUp 0.25s ease-out'
                        }}
                    >
                        {/* Header */}
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            padding: '1.25rem 1.5rem',
                            borderBottom: '1px solid #f1f5f9',
                            flexShrink: 0
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                <div style={{
                                    width: 38, height: 38, borderRadius: '10px',
                                    background: 'linear-gradient(135deg,#ff5722,#ff5722)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <svg width="18" height="18" fill="none" stroke="#fff" strokeWidth="2" viewBox="0 0 24 24">
                                        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
                                        <rect x="9" y="3" width="6" height="4" rx="1"/>
                                        <path d="M9 12h6M9 16h4"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
                                        {ordersListTitle}
                                    </h3>
                                    <p style={{ margin: 0, fontSize: '0.78rem', color: '#64748b' }}>
                                        {ordersListLoading ? 'Chargement…' : `${ordersListData.length} commande${ordersListData.length !== 1 ? 's' : ''}`}
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={() => setOrdersListModal(false)}
                                style={{
                                    background: '#f1f5f9', border: 'none', borderRadius: '8px',
                                    width: 34, height: 34, cursor: 'pointer', display: 'flex',
                                    alignItems: 'center', justifyContent: 'center', color: '#64748b',
                                    transition: 'background 0.15s'
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = '#e2e8f0'}
                                onMouseLeave={e => e.currentTarget.style.background = '#f1f5f9'}
                            >
                                <X size={18} />
                            </button>
                        </div>

                        {/* Body */}
                        <div style={{ overflowY: 'auto', flex: 1, padding: '0.5rem 0' }}>
                            {ordersListLoading ? (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '3rem 1rem', color: '#94a3b8' }}>
                                    <div style={{
                                        width: 36, height: 36, border: '3px solid #e2e8f0',
                                        borderTopColor: '#3b82f6', borderRadius: '50%',
                                        animation: 'olSpin 0.7s linear infinite', marginBottom: '1rem'
                                    }} />
                                    <span style={{ fontSize: '0.875rem' }}>Chargement des commandes…</span>
                                </div>
                            ) : ordersListData.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '3rem 1rem', color: '#94a3b8' }}>
                                    <svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" style={{ margin: '0 auto 1rem', display: 'block' }}>
                                        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
                                        <rect x="9" y="3" width="6" height="4" rx="1"/>
                                    </svg>
                                    <p style={{ margin: 0, fontWeight: 600, color: '#475569', fontSize: '0.95rem' }}>Aucune commande trouvée</p>
                                    <p style={{ margin: '0.4rem 0 0', fontSize: '0.82rem' }}>Il n&apos;y a aucune commande pour cette période.</p>
                                </div>
                            ) : (
                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
                                        <thead>
                                            <tr style={{ background: '#f8fafc' }}>
                                                {['Référence', 'Date & heure', 'Canal', 'Statut', 'Montant'].map(h => (
                                                    <th key={h} style={{
                                                        padding: '0.85rem 1rem', textAlign: 'left',
                                                        fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase',
                                                        letterSpacing: '0.06em', color: '#64748b',
                                                        borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap'
                                                    }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ordersListData.map((cmd, idx) => {
                                                const statusLabel = getStatusLabel(cmd.statut, cmd.statut_paiement);
                                                const colorObj = statusColors[statusLabel] || statusColors["Annulée"];
                                                const montant = cmd.prix_commande ?? cmd.prix ??
                                                    (cmd.details?.reduce((s, d) => s + (d.prix_total || 0), 0) ?? 0);
                                                const canal = cmd._canalStr || cmd.canal || getCanalLabel(cmd.table_restaurant?.type_table ?? cmd.type_table);
                                                return (
                                                    <tr
                                                        key={cmd.id_commande ?? idx}
                                                        style={{
                                                            borderBottom: '1px solid #f1f5f9',
                                                            transition: 'background 0.12s'
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                                    >
                                                        <td style={{ padding: '0.9rem 1rem', fontWeight: 600, color: '#1e293b', whiteSpace: 'nowrap' }}>
                                                            <span style={{
                                                                display: 'inline-flex', alignItems: 'center', gap: '0.3rem',
                                                                background: '#f1f5f9', borderRadius: '6px',
                                                                padding: '2px 8px', fontSize: '0.8rem', fontFamily: 'monospace'
                                                            }}>
                                                                #{cmd.reference ? cmd.reference.toString().replace(/#/g,'').split('-').pop() : (cmd.id_commande ?? idx+1)}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '0.9rem 1rem', color: '#475569', whiteSpace: 'nowrap' }}>
                                                            {formatDate(cmd.date_commande)}
                                                        </td>
                                                        <td style={{ padding: '0.9rem 1rem', color: '#64748b', whiteSpace: 'nowrap' }}>
                                                            <span style={{
                                                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                                fontSize: '0.8rem'
                                                            }}>
                                                                {canal === 'Livraison' ? '🚚' : canal === 'QR Code Client' ? '📱' : '🍽️'} {canal}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '0.9rem 1rem' }}>
                                                            <span style={{
                                                                display: 'inline-block',
                                                                padding: '3px 10px', borderRadius: '20px',
                                                                fontSize: '0.75rem', fontWeight: 700,
                                                                background: colorObj.bg, color: colorObj.text,
                                                                whiteSpace: 'nowrap'
                                                            }}>
                                                                {statusLabel}
                                                            </span>
                                                        </td>

                                                        <td style={{
                                                            padding: '0.9rem 1rem', textAlign: 'right',
                                                            fontWeight: 700, color: '#0f172a', whiteSpace: 'nowrap'
                                                        }}>
                                                            {formatMontant(montant)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        {!ordersListLoading && ordersListData.length > 0 && (
                            <div style={{
                                borderTop: '1px solid #f1f5f9',
                                background: '#fafafa', flexShrink: 0,
                            }}>
                                {/* Totaux */}
                                <div style={{
                                    padding: '0.75rem 1.5rem',
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    flexWrap: 'wrap', gap: '0.5rem'
                                }}>
                                    <span style={{ fontSize: '0.82rem', color: '#64748b' }}>
                                        Total encaissé&nbsp;:
                                        <strong style={{ color: '#0f172a', marginLeft: 6 }}>
                                            {formatMontant(
                                                ordersListData
                                                    .filter(c => c.statut_paiement === 2)
                                                    .reduce((s, c) => s + (c.prix_commande ?? c.prix ?? (c.details?.reduce((a,d)=>a+(d.prix_total||0),0)??0)), 0)
                                            )}
                                        </strong>
                                    </span>
                                    <span style={{ fontSize: '0.82rem', color: '#64748b' }}>
                                        Total période&nbsp;:
                                        <strong style={{ color: '#0f172a', marginLeft: 6 }}>
                                            {formatMontant(
                                                ordersListData.reduce((s, c) => s + (c.prix_commande ?? c.prix ?? (c.details?.reduce((a,d)=>a+(d.prix_total||0),0)??0)), 0)
                                            )}
                                        </strong>
                                    </span>
                                </div>
                                {/* Boutons export */}
                                <div style={{
                                    padding: '0.65rem 1.5rem 0.85rem',
                                    display: 'flex', gap: '0.6rem', justifyContent: 'flex-end',
                                    borderTop: '1px solid #f1f5f9'
                                }}>
                                    <button
                                        onClick={exportCSV}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', gap: '6px',
                                            padding: '7px 16px', borderRadius: '8px', border: 'none',
                                            background: '#dcfce7', color: '#15803d', fontWeight: 700,
                                            fontSize: '0.8rem', cursor: 'pointer', transition: 'background 0.15s'
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background='#bbf7d0'}
                                        onMouseLeave={e => e.currentTarget.style.background='#dcfce7'}
                                        title="Exporter en CSV (compatible Excel)"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                        CSV
                                    </button>
                                    <button
                                        onClick={exportPDF}
                                        style={{
                                            display: 'inline-flex', alignItems: 'center', gap: '6px',
                                            padding: '7px 16px', borderRadius: '8px', border: 'none',
                                            background: '#f1dad2', color: '#ff5722', fontWeight: 700,
                                            fontSize: '0.8rem', cursor: 'pointer', transition: 'background 0.15s'
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background='#ecc6baff'}
                                        onMouseLeave={e => e.currentTarget.style.background='#f1dad2'}
                                        title="Exporter et imprimer en PDF"
                                    >
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                                        PDF
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Animations */}
                    <style>{`
                        @keyframes olFadeIn { from{opacity:0} to{opacity:1} }
                        @keyframes olSlideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
                        @keyframes olSpin { to{transform:rotate(360deg)} }
                    `}</style>
                </div>
            )}
        </div>
    );
};

export default AccueilNew;
